import { pxToRem, remToPx } from '../utils';

export const spacing = {
  '0': '0',
  '4': '0.25rem', // 4px
  '8': '0.5rem', // 8px
  '12': '0.75rem', // 12px
  '16': '1rem', // 16px
  '20': '1.25rem', // 20px
  '24': '1.5rem', // 24px
  '28': '1.75rem', // 28px
  '32': '2rem', // 32px
  '40': '2.5rem', // 40px
  '52': '3.25rem', // 52px
  '60': '3.75rem', // 60px
  '80': '5rem', // 80px
  '100': '6.25rem', // 100px
  '120': '7.5rem', // 120px
  pxToRem,
  remToPx,
} as const;

export type Spacing = typeof spacing;
